var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.114,
    height: 23.315,
    viewBox: "0 0 27.114 23.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567",
    transform: "translate(-874.5 4819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M42.773,29.1a.581.581,0,0,0,0-.063V25.759a.589.589,0,0,0-.589-.589H37.468a.589.589,0,0,0-.589.589v3.273a.582.582,0,0,0,.028.173,6.488,6.488,0,1,0,5.867-.11Zm-4.716-.652V26.349h3.537v2.094Zm1.9,11.789a5.3,5.3,0,1,1,5.3-5.3,5.3,5.3,0,0,1-5.3,5.3Z",
    transform: "translate(848.098 -4844.17)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M20.608,49.089a.589.589,0,0,0-.589-.589h-3.93a.589.589,0,1,0,0,1.179h3.93A.589.589,0,0,0,20.608,49.089Z",
    transform: "translate(859 -4858.332)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M28.092,64.982,25.31,67.761a.589.589,0,1,0,.833.833l2.778-2.778a.589.589,0,0,0-.829-.833Z",
    transform: "translate(853.159 -4868.252)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M49.089,71.5a.589.589,0,0,0-.589.589v3.93a.589.589,0,1,0,1.179,0v-3.93A.589.589,0,0,0,49.089,71.5Z",
    transform: "translate(838.968 -4872.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M65.789,64.956a.589.589,0,0,0-.833.833l2.778,2.778a.589.589,0,0,0,.833-.833Z",
    transform: "translate(829.075 -4868.225)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M76.019,48.5h-3.93a.589.589,0,0,0,0,1.179h3.93a.589.589,0,1,0,0-1.179Z",
    transform: "translate(825.006 -4858.332)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M65.35,29.15a.589.589,0,0,0,.417-.173L68.545,26.2a.589.589,0,0,0-.833-.833l-2.778,2.778a.589.589,0,0,0,.417,1.006Z",
    transform: "translate(829.096 -4844.192)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M28.144,28.971a.589.589,0,0,0,.833-.833L26.2,25.356a.589.589,0,0,0-.833.833Z",
    transform: "translate(853.107 -4844.187)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/Icon_Light.c10adcbc3f59da1536f4de7bca29dc88.svg";
export { ForwardRef as ReactComponent };